<template>
    <div class="border-b border-[#eeeff2] py-3">
        <span class="block text-[20px] font-[CircularBook] text-center">Trade History</span>
    </div>
    <div
        class="flex items-center h-[calc(100%-64px)]"
        v-if="tradeHistoryAllLoading"
    >
        <Loading />
    </div>
    <div class="relative overflow-x-hidden table-wrapper" v-if="!tradeHistoryAllLoading">
        <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 price-table whitespace-nowrap scrollable-table">
            <thead>
            <tr class="text-[#2a395a] text-[12px] font-[CircularBook] tracking-wider border-b border-[#eeeff2]">
                <th scope="col" class="ps-5 pe-2 py-2.5">
                    Price
                </th>
                <th scope="col" class="px-2 py-2.5 text-right">
                    Amount
                </th>
                <th scope="col" class="px-5 py-2.5 text-right">
                    Date
                </th>
            </tr>
            </thead>
            <tbody class="text-[12px] font-[CircularBook]">
                <tr v-for="trade in tradeHistoryAll">
                    <td class="ps-5 pe-2 py-[0] text-[#2a395a]" :class="trade.direction === 'BUY' ? 'text-success' : 'text-danger'">
                        {{ trade.price }}
                    </td>
                    <td class="px-2 py-[0] text-right text-[#2a395a]">
                        {{ trade.amount }}
                    </td>
                    <td class="ps-2 pe-5 py-[0] text-right text-[#2a395a]">
                        {{ computedTimezoneDate(trade.date) }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script setup>
import {backendSocket} from "../../sockets";
import { onMounted, ref } from "vue";
import axios from "axios";
import moment from "moment";
import Loading from "../Loading.vue";

const tradeHistoryAll = ref({})
const tradeHistoryAllLoading = ref(true);
const market = pageData.market

const computedTimezoneDate = (date) => {
    return moment(date).format("HH:mm:ss")
}

onMounted(() => {
    axios.post("/exchange/query/all-trading-history", {marketId: market.id}).then(({ data: { data } }) => {
        tradeHistoryAll.value = data
        tradeHistoryAllLoading.value = false;
    }).catch(({ response: {data} }) => {
        console.log(data)
    });

    backendSocket.channel(`exchange.public.${market.id}`).listen('.public_trade.created', ({ trade }) => {
        tradeHistoryAll.value.unshift(trade)
    })
})

</script>

